import { render, staticRenderFns } from "./refundOrder.vue?vue&type=template&id=23b8d65e&scoped=true&"
import script from "./refundOrder.vue?vue&type=script&lang=js&"
export * from "./refundOrder.vue?vue&type=script&lang=js&"
import style0 from "./refundOrder.vue?vue&type=style&index=0&id=23b8d65e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b8d65e",
  null
  
)

export default component.exports